export const RECOVERY_SUPPORT_EMAIL = 'support@white-line.pro';